import CWFResponsiveDialog from "@/components/ui/CWFResponsiveDialog";
import Avatar from "@/components/General/Avatar";
import Link from "next/link";

export default function LikeModal({likeOpen, setLikeOpen, likes}){
    return(
        <CWFResponsiveDialog
            open={likeOpen}
            onOpenChange={setLikeOpen}
            title={<p>Aimé par</p>}
            trigger={null}
        >
            <div className={"max-h-60 overflow-y-scroll grid gap-4"}>
                {likes.map(function(like){
                    return(
                        <div key={like.id} className={"flex items-center gap-x-4"}>
                            <Avatar url={like.user.docs[0]?.path} width={50} height={50}/>
                            <div>
                                <Link href={`/profile/${like.user.id}`}>
                                    <button
                                        className={"font-medium hover:underline"}
                                    >
                                        {like.user.firstname} {like.user.lastname}
                                    </button>
                                </Link>

                            </div>
                        </div>
                    )
                })}
            </div>

        </CWFResponsiveDialog>
    )
}